export let STREAM_SOCKET_MESSAGES = /*#__PURE__*/function (STREAM_SOCKET_MESSAGES) {
  STREAM_SOCKET_MESSAGES["UPDATE"] = "live-stream-notification";
  return STREAM_SOCKET_MESSAGES;
}({});
//# sourceMappingURL=stream-socket-messages.js.map